import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  item: null,
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createAddress({ commit }, item) {
    return this.$axios.$post('admin/addresses/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
      return response.data
    })
  },
  removeAddress({ commit }, item) {
    return this.$axios.$delete(`admin/addresses/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateAddress({ commit }, item) {
    return this.$axios.$put(`admin/addresses/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
      return response.data
    })
  },
  fetchAddress({ commit }, id) {
    return this.$axios.$get(`admin/addresses/${id}`).then((response) => {
      return response.data
    })
  },
  fetchAddresses({ commit }) {
    return this.$axios.$get('admin/addresses').then((response) => {
      commit('load', response.data)
      return response.data
    })
  },
}
